import { render, staticRenderFns } from "./EducationBoard.vue?vue&type=template&id=1477e190&"
import script from "./EducationBoard.vue?vue&type=script&lang=js&"
export * from "./EducationBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports